import { PAGES, ReactQueryKeys } from 'common/enums';
import { useQuery } from '@tanstack/react-query';
import { requestService } from 'services/requests-service/requests-service';
import { modifyFilter } from './utils';
import { useIsUserHaveRole } from 'hooks/use-is-user-have-role';
import { USER_ROLES } from '../../../../constants';

export const useMyRequestsFilers = () => {
  const isWorkshopOrAdminUser = useIsUserHaveRole([USER_ROLES.workshop.id, USER_ROLES.administrator.id]);

  const {
    data: filters,
    isFetching: filterIsFetching,
    refetch
  } = useQuery({
    queryKey: [PAGES.MY_REQUESTS, ReactQueryKeys.Filter],
    queryFn: () => requestService.getRepairPartnerFilters(),
    select: modifyFilter,
    enabled: isWorkshopOrAdminUser && window.location.pathname === PAGES.MY_REQUESTS
  });

  return {
    filters,
    filterIsFetching,
    refetch
  };
};
